import React from 'react';

import { ReactComponent as Cart } from '../../assets/cart.svg';
import { ReactComponent as FileFormats } from '../../assets/fileFormats.svg';
import { ReactComponent as Payments } from '../../assets/payments.svg';

import s from './index.module.css';

const KeyFeatures = () => (
  <section className={s.keyFeaturesSection}>
    <h2 className={s.keyFeaturesHeader}>Выгодно и удобно</h2>
    <div className={s.blocks}>
      <div className={s.uploadFiles}>
        <div className={s.fileFormats}>
          <FileFormats className={s.fileFormatsIcon} />
        </div>
        <div className={s.filesText}>Загружайте предложения в привычном формате</div>
      </div>
      <div className={s.orders}>
        <Cart className={s.cartIcon} />
        <div className={s.ordersText}>Получайте готовые заказы от новых покупателей</div>
      </div>
      <div className={s.invoiceInfo}>
        <Payments className={s.paymentsIcon} />
        <div className={s.invoiceText}>3 599 ₽ — средний чек заказа из Смартби</div>
      </div>
    </div>
  </section>
);

export default KeyFeatures;
